import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { IPagination } from 'lingo2-models';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent extends ChangableComponent {
  @Input() set enabled(value: boolean) {
    this.onBrowserOnly(() => {
      this.clearTimeout(this._timeout1);
      if (value) {
        this._timeout1 = this.setTimeout(() => {
          this._enabled = value;
          this.detectChanges();
        }, 500);
      } else {
        this._enabled = value;
      }
      });
  }
  get enabled(): boolean {
    return this._enabled;
  }
  @Input() loading: boolean;
  @Input() pagination: IPagination;
  @Input() baseUrl: string;
  @Input() nothingMoreText = 'pagination.nothing-more';
  @Output() nextPage = new EventEmitter<number>();

  private _enabled: boolean;
  private _timeout1: any;
  private _timeout2: any;

  constructor(protected readonly cdr: ChangeDetectorRef, protected readonly platform: PlatformService) {
    super(cdr, platform);
  }

  public onInViewportChange(inViewport) {
    this.onBrowserOnly(() => {
      if (this.enabled && inViewport.visible) {
        this.clearTimeout(this._timeout2);
        this._timeout2 = this.setTimeout(() => this.goNextPage(), 500);
      }
      });
  }

  public goNextPage(e?: Event) {
    if (e) {
      e.preventDefault();
      e.cancelBubble = true;
    }
    this.nextPage.emit(this.pagination.page + 1);
  }
}
